import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'environment/environment';

import { BaseListReqParams } from 'modules/shared/models/base.models';
import { Domain } from 'modules/shared/models/domain.models';
import { DomainResponse, DomainPayload, DomainsQuery } from 'store/models/domain.models';

@Injectable()
export class DomainService {

  constructor(private http: HttpClient) { }

  getDomains(userId: string, payload?: DomainsQuery) {
    let url = `${environment.API_BASE}/api/users/${userId}/domains/`;
    url += payload ? `?limit=${payload.limit}` : '';
    return this.http.get<DomainResponse>(url);
  }

  createDomains(payload: DomainPayload): Observable<Domain> {
    const url = `${environment.API_BASE}/api/domains/`;
    const body = {
      domain_name: payload.domainName
    };
    return this.http.post<Domain>(url, body);
  }

  getAllDomains(payload: BaseListReqParams): Observable<DomainResponse> {
    let url = `${environment.API_BASE}/api/domains/?`;
    url += `limit=${payload.limit}`;
    url += `&offset=${payload.offset}`;
    url += payload.sort ? `&sort=${payload.sort}` : '';
    return this.http.get<DomainResponse>(url);
  }
}
